import config from 'Config';

// Return a specified "fixed" string when we are in a testing environment
// (more specifically in a CONCOURSE env (e.g. CI))
export default ({ value, fixed }: { value: string; fixed: string }) => (config.IS_DRONE ? fixed : value);
